<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    allowBack: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
  },
  methods: {
    goBack() {
      if (this.backUrl !== '') {
        this.$router.push(this.backUrl);
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<template>
  <header class="mb-6">
    <!-- Header Row -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
      <h1 class="flex items-center text-2xl text-slate-900 dark:text-slate-100 mb-4 md:mb-0">
        <div v-if="allowBack" @click="goBack">
          <fluent-icon
            icon="chevron-left"
            class="ml-1 mr-2 rtl:ml-2 rtl:mr-1 md:block text-slate-500 hover:text-slate-800 cursor-pointer"
          />
        </div>
        <fluent-icon
          v-if="icon"
          :icon="icon"
          class="hidden ml-1 mr-2 rtl:ml-2 rtl:mr-1 md:block text-woot-500"
          aria-hidden="true"
        />
        <span class="text-2xl font-medium text-slate-900 dark:text-slate-100">
          {{ title }}
        </span>
      </h1>

      <!-- Actions Slot -->
      <div class="flex gap-4 items-center">
        <slot name="actions" />
      </div>
    </div>

    <!-- Description -->
    <div
      v-if="description && description.length!= 0"
      class="flex flex-col gap-3 text-slate-600 dark:text-slate-300 w-full bg-slate-50 dark:bg-slate-800/30 p-4 rounded-lg border border-slate-200 dark:border-slate-700"
    >
      <p
        class="mb-0 text-base font-normal line-clamp-5 sm:line-clamp-none tracking-[-0.1px]"
      >
        {{ description }}
      </p>
    </div>
  </header>
</template>
